export default "__VITE_ASSET__fc7c5d90__"